import type { IComponentController, IScope } from "angular";
import "angular-translate";

import type { IOperatorStationSlim, IResponseWithLoading } from "App/Modules/Models";
import type { IEquipmentRepository } from "App/Modules/Repositories";
import type { IFormContainerResolve } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class EditOperatorStationComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "$translate", "mmEquipmentRepository"];

    public operatorStation: IOperatorStationSlim;

    public displayValidationError = false;

    public patchResponse: IResponseWithLoading<IOperatorStationSlim>;

    public disconnectResponse: IResponseWithLoading<IOperatorStationSlim>;

    public resolve: IFormContainerResolve<IOperatorStationSlim, IOperatorStationSlim>;

    constructor(
        private readonly $scope: IScope,
        private readonly $translate: angular.translate.ITranslateService,
        private readonly equipmentRepository: IEquipmentRepository,
    ) {}

    public $onInit() {
        this.operatorStation = this.resolve.bindings;

        if (this.operatorStation) {
            this.$scope.$watch("$ctrl.operatorStation", (newValue) => {
                if (newValue !== undefined) {
                    this.displayValidationError = false;
                }
            });
        }
    }

    public disconnectOperatorStation() {
        const operatorStationPatch = {
            alarmCentralId: null,
        } as IOperatorStationSlim;

        extendWithLoadingAndFail(
            this.equipmentRepository.patchOperatorStation(this.operatorStation.id, operatorStationPatch),
        ).subscribe(
            (response) => {
                this.disconnectResponse = response;

                if (!response.isLoading && response.data) {
                    this.resolve.options.onOk(null);
                }
            },
            (error) => {
                this.disconnectResponse = error;
                this.displayValidationError = true;
            },
        );
    }

    public cancel() {
        if (this.resolve.options.onCancel) {
            this.resolve.options.onCancel();
        }
    }
}
